import { DecimalPipe, NgClass } from "@angular/common";
import { Component, computed, EventEmitter, input, Output, signal, ChangeDetectionStrategy } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { ProgressSpinnerModule } from "@openng/optimus-ui/progressspinner";
import { FormsModule } from "@angular/forms";
import { createTimeoutSignal } from "../../utils/timeout.utils";
import { TimeoutComponent } from "../../components/timeout/timeout.component";
import { BotevoDesignTokens } from "../../../../assets/themes/botevoPreset";
import { SvgIconComponent } from "../../components/svg-icon/svg-icon.component";

@Component({
  standalone: true,
  selector: "app-load-changes",
  imports: [
    TranslateModule,
    DecimalPipe,
    ProgressSpinnerModule,
    NgClass,
    FormsModule,
    TimeoutComponent,
    SvgIconComponent,
  ],
  templateUrl: "./load-changes.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./load-changes.component.scss",
})
export class LoadChangesComponent {
  public botevoDesignTokens = BotevoDesignTokens;
  public selectedTimeWindow = signal("total");

  public loadChanges = input<number | null>();
  public lastActionTimestamp = input<string | undefined>();

  public loading = computed(() => this.loadChanges() === null);
  public timeOut = createTimeoutSignal(this.loading);

  @Output() changeTimeframeEvent = new EventEmitter<string>();

  /**
   * Handler for time range change events emitted by the time window select dropdown.
   * @param event - The select element triggering the change event.
   */
  public onChangeTimeSelect(event: Event) {
    const timeWindow = (event.target as any).value;
    this.selectedTimeWindow.set(timeWindow);
    this.changeTimeframeEvent.emit(timeWindow);
  }
}
